import { EmployeeStats } from '../models/employee.models';

const STAT_ICON_STYLE = {
  position: 'absolute' as const,
  right: '0px',
  bottom: '0px',
  width: '110px',
  height: '110px',
  transform: 'rotate(-4deg)',
  'image-rendering': '-webkit-optimize-contrast' as const,
  filter: 'none'
};

export function buildEmployeeStats(total: number, active: number, onLeave: number): EmployeeStats[] {
  return [
    { title: 'Total Employees', value: total, color: 'green', icon: 'assets/images/employee/total-employees-icon.svg', iconClass: 'total-employees-icon', iconStyle: STAT_ICON_STYLE },
    { title: 'Active', value: active, color: 'blue', icon: 'assets/images/employee/active-employees-icon.svg', iconClass: 'active-employees-icon', iconStyle: STAT_ICON_STYLE },
    { title: 'On Leave', value: onLeave, color: 'orange', icon: 'assets/images/employee/on-leave-icon.svg', iconClass: 'on-leave-icon', iconStyle: STAT_ICON_STYLE },
    { title: 'Average Rating', value: '-', color: 'purple', icon: 'assets/images/employee/average-rating-icon.svg', iconClass: 'average-rating-icon', iconStyle: STAT_ICON_STYLE }
  ];
}
